import AppointmentPatient from "./AppointmentPatient";
export default AppointmentPatient;
